<template>
   <svg width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
     <path d="M14.03 11.48a2.55 2.55 0 11-5.1 0 2.55 2.55 0 015.1 0M15.57 2.84L13.62.9A3.06 3.06 0 009.3.9L7.35 2.84a2.6 2.6 0 000 3.68L9.53 8.7a3.38 3.38 0 013.88-.02l2.16-2.16a2.6 2.6 0 000-3.68M8.08 11.48c0-.71.23-1.37.6-1.92L6.52 7.4a2.6 2.6 0 00-3.68 0L.9 9.34a3.06 3.06 0 000 4.33l1.94 1.94a2.6 2.6 0 003.68 0l2.18-2.18a3.37 3.37 0 01-.62-1.95M15.61 16.44l-2.18-2.18a3.38 3.38 0 01-3.87.02L7.4 16.44a2.6 2.6 0 000 3.68l1.94 1.95a3.06 3.06 0 004.33 0l1.94-1.95a2.6 2.6 0 000-3.68M22.07 9.3l-1.95-1.95a2.6 2.6 0 00-3.68 0l-2.18 2.18a3.37 3.37 0 01.02 3.88l2.16 2.16a2.6 2.6 0 003.68 0l1.95-1.95a3.06 3.06 0 000-4.33"/>
   </svg>
</template>

<script>
export default {
   name: 'CanolaIcon'
}
</script>